import push from '../utils/push';

/**
 * @typedef {import('./product-datalayer').GAProduct} GAProduct
 * 
 * @typedef {Object} GATransactionAction
 * @property {string} id
 * @property {string} affiliation
 * @property {number} revenue
 * @property {number} shipping
 * @property {number} tax
 * @property {string} coupon
 * @property {boolean} subscription
 * @property {string} customer_type
 * 
 * @typedef {Object} TransactionActionDetails
 * @property {string} id
 * @property {string} affiliation
 * @property {number} revenue
 * @property {number} shipping
 * @property {number} tax
 * @property {string} coupon
 * @property {boolean} subscription
 * @property {string} customerType
 */

/**
 * @param {TransactionActionDetails} actionDetails
 * @returns {GATransactionAction}
 */
function buildTransactionAction(actionDetails) {
    const {
        id,
        affiliation,
        revenue,
        shipping,
        tax,
        coupon,
        subscription,
        customerType
    } = actionDetails;

    return {
        'id': id,
        'affiliation': affiliation,
        'revenue': revenue,
        'shipping': shipping,
        'tax': tax,
        'coupon': coupon,
        'subscription': subscription,
        'customer_type': customerType
    };
}

/**
 * @param {string} currencyCode
 * @param {GAProduct} product
 */
function sendAddToCart(currencyCode, product) {
    push({
        'event': 'add-to-cart',
        'ecommerce': {
            'currencyCode': currencyCode,
            'add': {
                'actionField': {},
                'products': [ product ]
            }
        }
    });
}

/**
 * @param {string} promoCode 
 */
function sendApplyPromo(promoCode) {
    push({
        'event': 'apply-promo',
        'promoSubmitted': promoCode
    });
}

/**
 * @param {string} currencyCode
 * @param {GAProduct} product
 */
function sendRemoveFromCart(currencyCode, product) {
    push({
        'event': 'remove-from-cart',
        'ecommerce': {
            'currencyCode': currencyCode,
            'remove': {
                'actionField': {},
                'products': [ product ]
            }
        }
    });
}

/**
 * @param {string} paymentType 
 * @param {string} currencyCode 
 * @param {GATransactionAction} action 
 * @param {Array<GAProduct>} products
 */

window.VCA = window.VCA || {};

window.VCA.cartDatalayer = {
    buildTransactionAction,
    sendAddToCart,
    sendApplyPromo,
    sendRemoveFromCart,
};

export {
    buildTransactionAction,
    sendAddToCart,
    sendApplyPromo,
    sendRemoveFromCart,
};
